<template>
  <v-dialog
    :value="visiblePopup"
    :width="1100"
    style='height: auto; min-width: 700px'
    @click:outside="closeClicked"
    @keydown.esc="closeClicked"
  >
    <v-card class="popup-wrapper workflow">
      <v-btn class="close-button" text @click="closeClicked" dense x-small>X</v-btn>
      <div class='work-flow-diagram' v-if='workFlowGraph'>
        <work-flow-graph :work-flow-graph="workFlowGraph"/>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import WorkFlowGraph from '@/components/workflows/WorkFlowGraph.vue';
import disableOuterScrollOnPopupVisible from '@/mixins/disableOuterScrollOnPopupVisible';

export default {
  name: 'WorkFlowDiagramPopup',
  mixins: [disableOuterScrollOnPopupVisible],
  components: { WorkFlowGraph },
  props: {
    workFlowGraph: {
      required: true,
    },
    visiblePopup: {
      required: true,
    },
  },
  methods: {
    closeClicked() {
      this.$emit('closed');
    },
  },
};
</script>

<style lang='scss'>
@import '~@/assets/styles/design-system';

.popup-wrapper {
  &.workflow .close-button {
    .v-btn__content {
      color: var(--brand-primary);
    }
  }
}
</style>

<style lang='scss' scoped>
@import '~@/assets/styles/design-system';

.popup-wrapper {
  &.workflow {
    padding: $space-6;
    display: flex;
    flex-direction: column;

    .close-button {
      .v-btn__content {
        color: var(--brand-primary);
      }

      align-self: flex-end;
      color: var(--brand-primary);
      margin-bottom: $space-5;
    }

    .work-flow-diagram {
      display: flex;
      justify-content: center;
    }
  }
}
</style>
